module.exports = __webpack_public_path__ + "img/gcdp1_2.340fbd15.jpg";